// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/.pnpm/css-loader@3.6.0_webpack@4.44.2/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".availability-item.booking-horizon {\n  font-size: 14px !important;\n}\n.availability-item.booking-horizon i {\n  vertical-align: -2px;\n  font-size: 16px;\n  display: inline-block;\n  margin: 0 10px 0 0;\n}\n", ""]);
// Exports
module.exports = exports;
